module.exports = __webpack_public_path__ + "img/016.ac3e2d2b.png";